export default __webpack_public_path__ + "static/media/desktop2.5dcd0519.webp";